import { useState, useEffect } from 'react'
import useAxios from 'axios-hooks'
import { useProgramContext } from 'providers/programProvider'
import {
  PROGRAM_SEARCH_DEFAULT_PARAMS as initialState,
  PROGRAM_COLUMNS,
  ORG_COLUMNS,
  PROGRAM_SEARCH_DEFAULT_ORG_PARAMS,
} from 'utils/constants'
import omitEmpty from 'omit-empty'
import { sanitizeParams } from 'utils/sanitizeParams'
import { pick } from 'lodash'

export const useSearch = (search = 'programs') => {
  const [params, setParams] = useState()
  const [, dispatch] = useProgramContext()

  const updatedParams = { ...initialState }
  if (search === 'organizations') {
    updatedParams.sort = 'programOrganization'
    updatedParams.group = ORG_COLUMNS
  } else {
    updatedParams.sort = initialState.sort
    updatedParams.group = []
  }

  const setFilter = (values) => {
    setParams({ ...initialState, ...params, ...values })
  }

  const clearFilters = () => {
    setParams({
      ...pick(params, 'sort', 'sortDirection', 'pageSize'),
      ...pick(initialState, 'paginated', 'page', 'member', 'inGoApply'),
    })
  }

  //Programs request
  const [
    { data: dataPrograms, loading: loadingPrograms, error: errorPrograms },
    executePrograms,
  ] = useAxios(
    {
      url: 'programs',
      method: 'POST',
      data: sanitizeParams({
        ...params,
        member: true,
        fieldList: search === 'programs' ? PROGRAM_COLUMNS : ORG_COLUMNS,
        ...(search === 'organizations' && PROGRAM_SEARCH_DEFAULT_ORG_PARAMS),
      }),
    },
    { manual: true }
  )

  //Organizations request
  const [
    {
      data: dataOrganizations,
      loading: loadingOrganizations,
      error: errorOrganizations,
    },
    executeOrganizations,
  ] = useAxios({ url: 'organizations' }, { manual: true })

  //Criteria request
  const [
    { data: dataCriteria, loading: loadingCriteria, error: errorCriteria },
    executeCriteria,
  ] = useAxios({ url: 'criteria' }, { manual: true })

  useEffect(() => {
    if (params) {
      executePrograms()
      dispatch({ type: 'SET_PARAMS', payload: params })
    }
  }, [params])

  return {
    dataPrograms,
    loadingPrograms,
    errorPrograms,
    executePrograms,
    setFilter,
    executeOrganizations,
    dataOrganizations,
    loadingOrganizations,
    errorOrganizations,
    executeCriteria,
    dataCriteria,
    loadingCriteria,
    errorCriteria,
    clearFilters,
    params,
  }
}
